import { Modal, Box, Typography, Button } from '@mui/material';
import { WhatsApp, Email } from '@mui/icons-material';
import TelegramIcon from '@mui/icons-material/Telegram';
import { ShareMapModalProps } from '../../../interfaces/ShareMap';
import { useTranslation } from 'react-i18next';
import { useToast } from '../../../hooks/useToast';

const ModalReferralCode: React.FC<ShareMapModalProps> = ({ isOpen, onClose, link, image }) => {
    const { t } = useTranslation();
    const { referralModalSuccess } = useToast();

    const shareMessage = t('referral:referral_modal_share_message');

    const copyToClipboard = () => {
        navigator.clipboard.writeText(link);
        onClose();
        referralModalSuccess();
    };

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            aria-labelledby="referral-code-modal"
        >
            <Box className="referral-modal" sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: { xs: '90%', sm: 400, md: 450 },
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
                borderRadius: '1rem'
            }}>
                <Typography id="referral-code-modal" variant="h6" component="h2" sx={{ textAlign: { xs: 'center', sm: 'left' } }}>
                    {t('referral:referral_modal_title')}
                </Typography>

                <div className="social-icons" style={{ display: 'flex', justifyContent: 'space-around', margin: '2rem 0rem' }}>
                    <a href={`https://wa.me/?text=${encodeURIComponent(shareMessage)}`} target="_blank" rel="noopener noreferrer">
                        <WhatsApp fontSize="large" color='success' />
                    </a>
                    <a href={`https://t.me/share/url?url=${encodeURIComponent(link)}&text=${encodeURIComponent(shareMessage)}`} target="_blank" rel="noopener noreferrer">
                        <TelegramIcon fontSize="large" color='primary' />
                    </a>
                    <a href={`mailto:?subject=Il mio codice referral&body=${encodeURIComponent(shareMessage)}`} target="_blank" rel="noopener noreferrer">
                        <Email fontSize="large" sx={{ color: '#E9495A' }} />
                    </a>
                </div>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        margin: '0.6rem 0rem 1rem 0rem',
                    }}
                >
                    <Box
                        sx={{
                            flex: 1,
                            height: '1px',
                            backgroundColor: '#E0E0E0',
                        }}
                    />
                    <Box
                        sx={{
                            px: 2,
                            fontSize: '0.875rem',
                            fontWeight: 'bold',
                            color: '#757575',
                        }}
                    >
                        {t('login:or')}
                    </Box>
                    <Box
                        sx={{
                            flex: 1,
                            height: '1px',
                            backgroundColor: '#E0E0E0',
                        }}
                    />
                </Box>
                <Box mt={2} sx={{ width: '100%' }}>
                    <Button
                        variant="contained"
                        color='error'
                        onClick={copyToClipboard}
                        fullWidth
                    >
                        {t('referral:referral_modal_button')}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default ModalReferralCode; 